import React from "react"
import novahra from "./novahra-btn.png"
import zebricekBtn from "./zebricek-btn.png"
import bgMenu from "./bg-menu.png"

type Props = {
  jmeno: string
  setJmeno: (v: string) => void
  onNovahra: () => void
  onPostavy: () => void
  onZebricek: () => void
}

export default function Menu({ jmeno, setJmeno, onNovahra, onPostavy, onZebricek }: Props) {
  return (
    <div className="menu-root falling-cookies-bg" style={{
      position: "fixed",
      inset: 0,
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      backgroundColor: "transparent",
      paddingTop: "0px"
    }}>
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
          pointerEvents: "none",
          backgroundImage: `url(${bgMenu})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 0.1
        }}
      />

      <div style={{ position: "relative", zIndex: 10, display: "flex", flexDirection: "column", alignItems: "center" }}>
      <img src={require("./cc-logo.png")} alt="Cookie Clicker" className="menu-logo" />

      <input
        className="menu-input"
        value={jmeno}
        onChange={(e) => setJmeno(e.target.value)}
        placeholder="Zadej své jméno..."
      />

      <div className="menu-buttons-vertical">
        <img src={novahra} alt="Nová hra" className="menu-btn-img" onClick={onNovahra} />
        <img src={zebricekBtn} alt="Žebříček" className="menu-btn-img" onClick={onZebricek} style={{ marginLeft: -7 }} />
      </div>
      </div>
    </div>
  )
}
